import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 44,
	height: 30,
	viewBox: "0 0 44 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.625 3.625H40.375M3.625 15H40.375M3.625 26.375H40.375",
		stroke: "currentColor",
		strokeWidth: 6,
		strokeMiterlimit: 10,
		strokeLinecap: "round"
	})
});
export default SvgMenu;
